import React, { useEffect, useState } from "react";
import { Activity, Clock } from "lucide-react";
import { api, fmtIDR, fmtDateShort } from "../../lib/api";
import { PageHeader, Panel, StatusBadge } from "../../lib/ui";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";

const DOT = { green: "bg-green-500", yellow: "bg-amber-400", red: "bg-red-500", purple: "bg-purple-500" };
const DOTLABEL = { green: "Aman", yellow: "≤3 hari", red: "Terlambat", purple: "Ada Rework" };

function Card({ label, value, tone }) {
  return <div className={`bg-white border border-taupe/20 rounded-lg p-4 ${tone || ""}`}><div className="text-xs text-wmuted">{label}</div><div className="text-2xl font-heading font-bold text-cocoa mt-1">{value}</div></div>;
}

export default function WIP() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/production/wip").then((r) => setData(r.data)); }, []);
  const s = data?.summary || {};
  return (
    <div data-testid="wip-page">
      <PageHeader title="Outstanding WIP" subtitle="Pantauan work-in-progress cutting & konveksi secara real-time" />
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-5">
        <Card label="Order Aktif" value={s.orders || 0} />
        <Card label="Total WIP (pcs)" value={s.total_wip || 0} />
        <Card label="Terlambat" value={s.overdue || 0} />
        <Card label="Jatuh Tempo ≤3 hari" value={s.due_soon || 0} />
      </div>

      <div className="flex items-center gap-3 mb-2 text-xs">
        {Object.entries(DOTLABEL).map(([k, v]) => <span key={k} className="flex items-center gap-1.5"><span className={`w-2.5 h-2.5 rounded-full ${DOT[k]}`} />{v}</span>)}
      </div>

      <div className="font-semibold text-cocoa mb-1.5">Outstanding Konveksi</div>
      <Panel className="mb-6">
        <Table>
          <TableHeader><TableRow className="hover:bg-transparent">
            <TableHead></TableHead><TableHead>No Order</TableHead><TableHead>Produk</TableHead><TableHead>Konveksi</TableHead>
            <TableHead className="text-right">Dikirim</TableHead><TableHead className="text-right">Diterima</TableHead><TableHead className="text-right">Outstanding</TableHead>
            <TableHead>Target</TableHead><TableHead className="text-right">Umur (hari)</TableHead><TableHead>Status</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {(data?.tailor || []).map((r) => (
              <TableRow key={r.id} data-testid={`wip-tailor-${r.id}`}>
                <TableCell><span className={`w-2.5 h-2.5 rounded-full inline-block ${DOT[r.indicator]}`} title={DOTLABEL[r.indicator]} /></TableCell>
                <TableCell className="font-mono text-xs">{r.number}</TableCell>
                <TableCell className="font-medium text-cocoa">{r.product_name}</TableCell>
                <TableCell>{r.partner_name}</TableCell>
                <TableCell className="text-right">{r.total_send}</TableCell>
                <TableCell className="text-right">{r.total_received}</TableCell>
                <TableCell className="text-right font-semibold">{r.outstanding}</TableCell>
                <TableCell>{fmtDateShort(r.target_date)}</TableCell>
                <TableCell className="text-right">{r.days_late != null ? (r.days_late > 0 ? `+${r.days_late}` : r.days_late) : "-"}</TableCell>
                <TableCell><StatusBadge status={r.status} /></TableCell>
              </TableRow>
            ))}
            {!(data?.tailor || []).length && <TableRow><TableCell colSpan={10} className="text-center text-wmuted py-8"><Activity className="w-6 h-6 mx-auto mb-2 opacity-50" />Tidak ada outstanding konveksi.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Panel>

      <div className="font-semibold text-cocoa mb-1.5">WIP Cutting</div>
      <Panel>
        <Table>
          <TableHeader><TableRow className="hover:bg-transparent">
            <TableHead></TableHead><TableHead>No Cutting</TableHead><TableHead>Produk</TableHead>
            <TableHead className="text-right">Target</TableHead><TableHead className="text-right">Hasil</TableHead>
            <TableHead>Target Selesai</TableHead><TableHead>Status</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {(data?.cutting || []).map((r) => (
              <TableRow key={r.id} data-testid={`wip-cutting-${r.id}`}>
                <TableCell><span className={`w-2.5 h-2.5 rounded-full inline-block ${DOT[r.indicator]}`} /></TableCell>
                <TableCell className="font-mono text-xs">{r.number}</TableCell>
                <TableCell className="font-medium text-cocoa">{r.product_name}</TableCell>
                <TableCell className="text-right">{r.target_qty}</TableCell>
                <TableCell className="text-right">{r.output_total}</TableCell>
                <TableCell>{fmtDateShort(r.target_date)}</TableCell>
                <TableCell><StatusBadge status={r.status} /></TableCell>
              </TableRow>
            ))}
            {!(data?.cutting || []).length && <TableRow><TableCell colSpan={7} className="text-center text-wmuted py-8"><Clock className="w-6 h-6 mx-auto mb-2 opacity-50" />Tidak ada WIP cutting.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Panel>
    </div>
  );
}
